import * as XLSX from "xlsx";
import { formatDate } from "../../../../utils/dateUtils";
import { getRiskLevel, getRiskStats } from "./riskUtils";

const scoreWithLevel = (score) => {
  if (score === null || score === undefined || score === "") return "-";
  return `${score} - ${getRiskLevel(score)}`;
};

const safe = (value) => (value === null || value === undefined || value === "" ? "-" : value);

const formatDateSafe = (value) => (value ? formatDate(value) : "-");

const DATA_SHEET_NAME = "Risk Assessment";
const SUMMARY_SHEET_NAME = "Summary";

export const exportRiskAssessmentToExcel = (risks = [], assessment = {}) => {
  try {
    const stats = getRiskStats(risks);

    // ----- Summary sheet -----
    const summaryData = [];
    summaryData.push(["Risk Assessment Report"]);
    summaryData.push([]);
    summaryData.push(["Assessment", safe(assessment?.title)]);
    summaryData.push(["Status", safe(assessment?.status_title)]);
    summaryData.push(["Conducted On", formatDateSafe(assessment?.created_at)]);
    summaryData.push(["Conducted By", safe(assessment?.assessor_email)]);
    summaryData.push(["Approved On", formatDateSafe(assessment?.completed_at)]);
    summaryData.push(["Approved By", safe(assessment?.approver_email)]);
    summaryData.push([
      "Last Updated",
      formatDateSafe(assessment?.updated_at || assessment?.created_at),
    ]);
    summaryData.push(["Total Risks", stats.total]);
    summaryData.push(["High Risks", stats.high]);
    summaryData.push(["Medium Risks", stats.medium]);
    summaryData.push(["Low Risks", stats.low]);
    summaryData.push(["Exported On", formatDateSafe(new Date().toISOString())]);
    summaryData.push([]);
    summaryData.push([
      `Open the "${DATA_SHEET_NAME}" tab below for the detailed risk breakdown.`,
    ]);

    const summaryWs = XLSX.utils.aoa_to_sheet(summaryData);
    summaryWs["!merges"] = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: 1 } },
      {
        s: { r: summaryData.length - 1, c: 0 },
        e: { r: summaryData.length - 1, c: 1 },
      },
    ];
    summaryWs["!cols"] = [{ wch: 22 }, { wch: 40 }];

    // ----- Data sheet -----
    const dataRows = [];
    dataRows.push([
      "Risk ID",
      "Risk Name",
      "Description",
      "Category",
      "Owner",
      "Inherent Impact",
      "Inherent Likelihood",
      "Inherent Score",
      "Residual Score",
      "Controls",
      "Treatment",
      "Comments",
    ]);

    risks.forEach((risk) => {
      dataRows.push([
        safe(risk?.risk_key),
        safe(risk?.risk_title),
        safe(risk?.risk_description),
        safe(risk?.risk_category_title),
        safe(risk?.risk_owner_email),
        safe(risk?.risk_inherent_impact),
        safe(risk?.risk_inherent_likelihood),
        scoreWithLevel(risk?.inherent_risk_score),
        scoreWithLevel(risk?.residual_risk_score),
        safe(risk?.controls_count),
        safe(risk?.treatment_title),
        safe(risk?.comments),
      ]);
    });

    const dataWs = XLSX.utils.aoa_to_sheet(dataRows);
    dataWs["!cols"] = [
      { wch: 10 }, // Risk ID
      { wch: 32 }, // Risk Name
      { wch: 45 }, // Description
      { wch: 22 }, // Category
      { wch: 28 }, // Owner
      { wch: 16 }, // Inherent Impact
      { wch: 18 }, // Inherent Likelihood
      { wch: 16 }, // Inherent Score
      { wch: 16 }, // Residual Score
      { wch: 10 }, // Controls
      { wch: 14 }, // Treatment
      { wch: 40 }, // Comments
    ];

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, summaryWs, SUMMARY_SHEET_NAME);
    XLSX.utils.book_append_sheet(wb, dataWs, DATA_SHEET_NAME);

    const titlePart = (assessment?.title || "Assessment")
      .replace(/[\\/:*?"<>|]/g, "")
      .replace(/\s+/g, "_");
    const timestamp = new Date().toISOString().split("T")[0];
    const filename = `Risk_Assessment_${titlePart}_${timestamp}.xlsx`;

    XLSX.writeFile(wb, filename);

    return { success: true };
  } catch (error) {
    console.error("Risk assessment export failed:", error);
    return { success: false, error };
  }
};
